import register from "common/bindings/registerBinding";

/**
 * Two-way binding for the menu widget.  The bound variable will match the open/close state of the menu.
 */
const openMenu = kendo.data.Binder.extend({
    init: function() {
        kendo.data.Binder.fn.init.apply(this, arguments);
        var me = this;
        this.element.bind("open", function() {
            me.bindings.open.set(true);
        });
        this.element.bind("close", function() {
            me.bindings.open.set(false);
        });
    },
    refresh: function() {
        var open = this.bindings.open.get();
        if (open) {
            this.element.open(this.element.element.children("li"));
        } else {
            this.element.close(this.element.element.children("li"));

        }
    }
});
register.widget("menu", "open", openMenu);
register.widget("dfmenu", "open", openMenu);

//Open binding for popup window
const openWindow = kendo.data.Binder.extend({
    init: function() {
        kendo.data.Binder.fn.init.apply(this, arguments);

        var me = this;
        this.element.bind("deactivate", function() {
            me.bindings.open.set(false);
        });
        this.element.bind("activate", function() {
            me.bindings.open.set(true);
        });
    },

    refresh: function() {
        var state = this.bindings.open.get();
        if (!state === this.element.isOpen()) {
            if (state) {
                this.element.open();
            } else {
                this.element.close();
            }
        }
    }
});
register.widget("popupwindow", "open", openWindow);
register.widget("errorwindow", "open", openWindow);

export default {
    popupwindow: openWindow,
    menu: openMenu
};
